import { Colors, Lightning, Router, Utils } from '@lightningjs/sdk';
import { Input } from '@lightningjs/ui-components';

// Components
import Button from '../components/Button';
import Border from '../components/InputField';
import Keyboard from '../../../components/Keyboard/components/Keyboard';

let inputField = 0;
export default class EmailLogin extends Lightning.Component {
  static _template() {
    return {
      Logo: {
        x: 730,
        y: 170,
        w: 470,
        h: 67,
        texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 470, 67),
      },
      Title: {
        y: 283,
        w: 1920,
        text: {
          text: 'Log in with your email',
          textColor: Colors('#fafafa').get(),
          fontFace: 'OpenSans-SemiBold',
          fontSize: 63,
          lineHeight: 78,
          textAlign: 'center',
        },
      },
      InputContainer: {
        collision: true,
        rect: true,
        x: 613,
        y: 420,
        w: 695,
        h: 67,
        color: Colors('#d6d6d6').get(),
        shader: { type: Lightning.shaders.RoundedRectangle, radius: 15 },
        Border: {
          type: Border,
        },
        InputField: {
          w: 695,
          h: 67,
          Input: {
            type: Input,
            y: 5,
            x: 5,
            w: 685,
            h: 57,
            listening: false,
            style: {
              backgroundColor: Colors('#D6D6D6').alpha(1).get(),
              textStyle: {
                textColor: Colors('#444444').alpha(1).get(),
                fontSize: 33,
                fontFace: 'OpenSans-Regular',
              },
              cursorStyle: {
                textColor: Colors('#444444').alpha(1).get(),
              },
            },
          },
        },
      },
      Placeholder: {
        w: 695,
        h: 67,
        x: 650,
        y: 430,
        text: { text: 'Email', fontSize: 33, fontFace: 'OpenSans-Regular' },
        color: Colors('#444444').get(),
      },
      BtnContainer: {
        collision: true,
        x: 683,
        y: 530,
        w: 556,
        h: 75,
        rect: true,
        color: Colors('#292929').get(),
        shader: { type: Lightning.shaders.RoundedRectangle, radius: 15 },
        ContinueBtn: {
          w: 556,
          h: 70,
          collision: true,
          type: Button,
          color: Colors('#444444').get(),
          InputText: {
            x: 209,
            y: 15,
            text: {
              text: 'Continue',
              textColor: Colors('#ffffff').get(),
              fontFace: 'OpenSans-Regular',
              fontSize: 33,
              lineHeight: 40,
            },
          },
        },
      },
      Border: {},
      Keyboard: {
        type: Keyboard,
        y: 650,
        w: 1920,
        rect: true,
        color: Colors('#000000').alpha(0).get(),
        flex: { direction: 'column', justifyContent: 'center', alignItems: 'center' },
        visible: false,
        limit: 45,
      },

      InvalidEmail: {},
    };
  }

  _changePlaceholder() {
    const isInputEmpty = this._InputField.tag('Input').value === '';
    this.tag('Placeholder').patch({
      visible: isInputEmpty,
    });
  }

  get _InputField() {
    return this.tag('InputField');
  }

  $addInputListen() {
    this._InputField.tag('Input').listening = true;
  }

  $removeInputListe() {
    this._InputField.tag('Input').listening = false;
  }

  $setState(state) {
    this._setState(state);
    if ((state == 'ContinueBtn' || state == 'InputField') && this.tag('Keyboard').visible) {
      this.$removeInputListe();
    }
    if (state == 'Keyboard') {
      this.$addInputListen();
    }
  }

  _firstActive() {
    this._setState('InputField');
    this.tag('InputField.Input').patch({
      text: {
        textColor: Colors('#444444').get(),
        text: 'Email',
        fontFamily: 'OpenSans-Regular',
        fontSize: 33,
      },
    });
  }

  _handleBack() {
    if (this.tag('Keyboard').visible) {
      this.tag('Keyboard').visible = false;
      this._setState('InputField');
      this._InputField.tag('Input').listening = false;
    } else {
      Router.back();
    }
  }

  get _ContinueBtn() {
    return this.tag('ContinueBtn');
  }

  validateEmail(value) {
    if (value) {
      var mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (value.match(mailFormat)) {
        return true;
      }
    } else {
      this.tag('InvalidEmail').patch({
        x: 780,
        y: 650,
        color: Colors('#ff0000').get(),
        text: {
          text: 'You entered an invalid email address.',
          fontSize: 21,
        },
      });
      return false;
    }
  }

  static _states() {
    return [
      class InputField extends this {
        _getFocused() {
          return this.tag('InputContainer.Border');
        }

        _handleDown() {
          this._setState('ContinueBtn');
        }

        _handleClick() {
          this._handleEnter();
        }

        _handleEnter() {
          this.$addInputListen();
          this.tag('Keyboard').visible = true;
          this._setState('Keyboard');
          this.tag('InputField.Input').patch({
            text: {
              text: inputField === 0 ? 'Email' : '',
            },
          });
        }
      },

      class ContinueBtn extends this {
        _getFocused() {
          return this.tag('ContinueBtn');
        }

        _handleUp() {
          this._setState('InputField');
        }

        _handleDown() {
          if (this.tag('Keyboard').visible) {
            this._setState('Keyboard');
          }
        }

        _handleClick() {
          this._handleEnter();
        }

        _handleEnter() {
          const inputValue = this._InputField.tag('Input').value;
          const isValidEmail = this.validateEmail(inputValue);
          this.tag('InputField.Input').patch({
            text: {
              textColor: Colors('#444444').get(),
              text: inputValue ? inputField : 'Email',
              fontFamily: 'OpenSans-Regular',
              fontSize: 33,
            },
          });

          if (!isValidEmail) {
            this.tag('InvalidEmail').patch({
              x: 780,
              y: 650,
              color: Colors('#ff0000').get(),
              text: {
                text: 'You entered an invalid email address.',
                fontSize: 21,
              },
            });
          } else {
            this.tag('InvalidEmail').patch({
              x: 780,
              y: 650,
              color: Colors('#ff0000').get(),
              text: {
                text: '',
                fontSize: 21,
              },
            });
            Router.navigate('login-with-password', { email: inputValue });
          }
        }
      },

      class Keyboard extends this {
        _getFocused() {
          this.$addInputListen();
          return this.tag('Keyboard');
        }

        _handleUp() {
          this._setState('ContinueBtn');
          this.tag('Keyboard').visible = false;
          this._InputField.tag('Input').listening = false;
        }
      },
    ];
  }
}
